import { writable } from "svelte/store";
export let url = writable("");
